<template>
  <div class="echarts-content">
    <div class="echarts" :style="{height: windowHeight + 'px'} ">
      <chart theme="macarons" :options="polar" ref="echar" :init-options="initOptions" :auto-resize="true" />
    </div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import theme from '../ECharts/macarons.json'
import 'echarts/theme/dark'
import { areaList } from '../api/ordersStatistics'
ECharts.registerTheme('macarons', theme)

export default {
  name: 'supplyCharts',
  props: {
    searchData: {
      default: {}
    },
    slider: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      windowHeight: '',
      info: {},
      polar: {
        title: {
          text: '发货数量',
          x: 'center'
        },
        tooltip: {
          // trigger: 'item',
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: [{
          type: 'category',
          data: [],
          axisLabel: {
            'interval': 0,
            formatter: function (val) {
              return val.split('').join('\n')
            }
          }
        }],
        yAxis: [{
          axisLabel: {
            formatter: '{value}'
          },
          axisTick: {
            show: false
          }
        }, {
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          }
        }],
        dataZoom: [{
          type: 'slider',
          xAxisIndex: 0,
          start: 0,
          end: 15,
          top: 0
        }],
        series: [{
          type: 'bar',
          data: []
        }]
      },
      initOptions: {}
    }
  },
  watch: {
    slider (val) {
      if (val) {
        this.init(this.searchData)
      }
    }
  },
  created () {
    this.$nextTick(() => {
      this.windowHeight = document.documentElement.offsetHeight - 370
    })
  },
  methods: {
    init () {
      let _this = this
      this.$refs.echar.clear()
      this.$refs.echar.showLoading()
      areaList(this.searchData).then(res => {
        _this.$refs.echar.hideLoading()
        if (res.data.data == null) {
          this.polar.series = []
          return
        }
        let data = res.data.data
        if (data.length > 30 && data.length < 50) {
          _this.polar.dataZoom[0] = {
            type: 'slider',
            xAxisIndex: 0,
            start: 0,
            end: 50,
            top: 0
          }
        } else if (data.length < 30) {
          _this.polar.dataZoom[0] = {
            type: 'slider',
            xAxisIndex: 0,
            start: 0,
            end: 100,
            top: 0
          }
        } else {
          _this.polar.dataZoom[0] = {
            type: 'slider',
            xAxisIndex: 0,
            start: 0,
            end: 10,
            top: 0
          }
        }
        let xData = data.map(v => v.province)
        let sData = data.map(v => v.count)
        let sum = 0
        sData.forEach(v => {
          sum += v
        })
        _this.polar.formatter = (params) => {
          let str = ''
          params.forEach((item, idx) => {
            str += `${item.marker}${item.axisValue}: ${item.data}</br>` + '占比: ' + (Math.round(item.data / sum * 100)) + '%'
          })
          return str
        }
        _this.polar.xAxis[0].data = xData
        _this.polar.series[0].data = sData
      })
    }
  },
  components: {
    chart: ECharts
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .echarts-content
    display flex
    flex-direction row
    justify-content space-between
  .echarts
    width: 100%
    height 100%
    margin-right: 5px
    text-align: center
    background: #fff
  .echartList
    margin-left 30px
    width 100%
    .el-table
      &:before
        height: 0 !important
  .dataListDetail
    font-size 12px
    margin -15px
    padding: 0 6px
    .flex-row
      display: flex
      flex-direction: row
      margin-bottom: 10px
      color: #999
      .mark
        margin-right: 30px
        white-space: nowrap
        color: #999
</style>
